import classnames from 'classnames';
import { Children, type FC, type ReactNode } from 'react';

import styles from 'molecules/ThreeColumnGrid/3-column-grid.module.scss';

interface ThreeColumnGridProps {
  children: ReactNode;
  classes?: Record<string, string>;
}

const ThreeColumnGrid: FC<ThreeColumnGridProps> = ({ children, classes = {} }) => (
  <div
    className={classnames(styles.container, {
      [classes.container]: classes.container,
    })}
  >
    <div
      className={classnames(styles.grid, {
        [classes.grid]: classes.grid,
      })}
    >
      {Children.map(children, (item, index) => (
        <div
          className={classnames(styles.gridItem, {
            [classes.gridItem]: classes.gridItem,
          })}
          key={`item-${index}`}
        >
          {item}
        </div>
      ))}
    </div>
  </div>
);

export default ThreeColumnGrid;
